import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import Image from '@/components/UI/Image';

export default function StoryNewNight() {
    const { useLang, isMobile } = useGlobal();
    const { t } = useLang('brandstory');

    return (
        <div id="storyNewnight" className={`${isMobile ? styled.mobile_newnight : styled.newnight} storyNewlight ${isMobile ? '' : 'content'}`}>
            <div className="header">
                <h5 className="screen-title">{t('menu.newnight')}</h5>
                <h5 className="screen-desc">{t('newnight.title')}</h5>
            </div>
            <div className="content-box">
                <div className="content-box__text">
                    <div className="left-text paraga">{t('newnight.paraga')}</div>
                    <div className="left-text paragb">{t('newnight.paragb')}</div>
                    <div className="left-text paragc">{t('newnight.paragc')}</div>
                    <div className="left-text paragd">{t('newnight.paragd')}</div>
                </div>
                <div className="content-box__img">
                    <Image src="/img/stories/common/night/newnight.jpg" className="fullImgs" layout="fill" />
                </div>
            </div>
        </div>
    );
}
